import { createFileRoute } from "@tanstack/react-router";
import {
  Box,
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
  Icon,
  ScrollArea,
  Spinner,
  Switch,
  Text,
} from "@salestrak/ui";
import { PageHeader, PageHeaderSubtitle, PageHeaderTitle } from "#app/components/page-header";
import { useUpdatesSettings } from "#app/lib/hooks/use-updates-settings";
import { SettingsGroup, SettingsGroupRow } from "#app/components/settings/settings-group";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";

function UpdatesPage() {
  const { push } = useAppNavigate();
  const { settings, hasData, isLoading, error, updateSetting } = useUpdatesSettings();

  if (isLoading && !hasData) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  if (error && !hasData) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Empty>
          <EmptyHeader>
            <EmptyTitle>Unable to load settings</EmptyTitle>
            <EmptyDescription>{error.message}</EmptyDescription>
          </EmptyHeader>
        </Empty>
      </Box>
    );
  }

  return (
    <Box direction="column" fill="flex">
      <ScrollArea>
        <PageHeader centered>
          <PageHeaderTitle>Project age updates</PageHeaderTitle>
          <PageHeaderSubtitle>
            Age reflects the time that has passed since the project was last updated by a user or the system.
          </PageHeaderSubtitle>
        </PageHeader>
        <Box align="center" paddingY="md" paddingX="md">
          <Box gap="xl" fill="width" maxWidth={800}>
            <Box gap="md">
              <SettingsGroup>
                <SettingsGroupRow
                  label="Reasons"
                  subtitle="Additional input on age updates for more clarity using customizable choices."
                  onClick={() => push("/settings/reasons")}
                  actionsVisible
                >
                  <Box direction="row" gap="sm" align="center">
                    <Text size="sm" variant="muted">
                      {settings.reasonsEnabled ? "On" : "Off"}
                    </Text>
                    <Icon name="chevron-right" size="sm" color="muted" />
                  </Box>
                </SettingsGroupRow>
              </SettingsGroup>

              <SettingsGroup label="Comments">
                <SettingsGroupRow
                  label="Require comment"
                  subtitle="A comment must be made in order to manually update the project age."
                >
                  <Switch
                    checked={settings.requireComment}
                    onCheckedChange={(v) => updateSetting("requireComment", v)}
                  />
                </SettingsGroupRow>
              </SettingsGroup>
            </Box>
          </Box>
        </Box>
      </ScrollArea>
    </Box>
  );
}

export const Route = createFileRoute("/(app)/$workspace/settings/updates")({
  component: withPermission("reasons.manage", UpdatesPage),
});
